<template>
    <form @submit.prevent="saveComment">
        <div class="form-group">
            <FormTextarea v-model="form.message" placeholder="Add comment..."></FormTextarea>
        </div>
        <div class="form-group">
            <FormButton :pending="pending" pending-text="Saving" :disabled="!this.form.message.length">Comment</FormButton>
        </div>
    </form>
</template>

<script>
import FormTextarea from '../form/FormTextarea';
import FormButton from '../form/FormButton';

export default {
    components: {
        FormTextarea,
        FormButton
    },
    props: {
        post: {
            type: Object
        },
        user: {
            type: Object
        },
        pending: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            buttonText: 'Comment',
            form: {
                message: '',
            },
            error: {
                status: false,
                message: null
            }
        }
    },
    methods: {
        async saveComment() {
            this.$emit('commentSaved', this.form);
        }
    }
}
</script>

